import { brandKitValidator } from "@redotech/redo-content-builder-common/brand-kit";
import * as z from "zod";

export const getBrandKit = {
  name: "getBrandKit" as const,
  input: z.null(),
  output: brandKitValidator,
};
